import React from 'react'
import { Grid, FormControl, TextField, Button } from '@material-ui/core'
import NumberFormat from 'react-number-format'
import Stack from '@mui/material/Stack'
import Moment from 'moment'
import './Style/crearFormulario.scss'
import { useFormElegibilidad } from '../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../context/EligibilityContext'

const ElegibilidadSec1View = (props) => {
  const { goToStep } = props

  const { EligibilityForm } = useFormElegibilidad()
  const [, dispatch] = useEligibility()

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }
  return (
    <>
      <form id="Sec1-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">INFORMACIÓN GENERAL</h1>
          <br />
        </Grid>

        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1. Nombre de la MIPYME
              </label>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1.2. Seleccione el proyecto
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeName"
                  name="MiPymeName"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.MiPymeName}
                />
              </FormControl>
            </Grid>
            {/** proyecto select */}
            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  id="IdProject"
                  name="IdProject"
                  variant="outlined"
                  value={EligibilityForm.ProjectName}
                  disabled
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.2. Período estimado de implementación de la inversión
              </label>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      min: '2021-06-30',
                    }}
                    value={Moment(
                      EligibilityForm.ImplementationDateStart,
                    ).format('YYYY-MM-DD')}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    sx={{ width: 220 }}
                    disabled
                    value={Moment(EligibilityForm.ImplementationDateEnd).format(
                      'YYYY-MM-DD',
                    )}
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.3. Fecha de presentación del formato de formulación del
                subproyecto
              </label>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="PresentationDate"
                    name="PresentationDate"
                    type="date"
                    variant="outlined"
                    value={Moment(EligibilityForm.PresentationDate).format(
                      'YYYY-MM-DD',
                    )}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.4. País donde se solicitará el crédito
              </label>{' '}
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    value={EligibilityForm.MiPymeCountry}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.5. Institución Financiera
              </label>{' '}
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="MiPymeCountry"
                    name="MiPymeCountry"
                    type="text"
                    variant="outlined"
                    value={EligibilityForm.IFIName}
                    sx={{ width: 220 }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.6. Presupuesto total del proyecto{' '}
              </label>
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Moneda</label>
              </Grid>
              <FormControl fullWidth>
                <TextField
                  id="IdCurrencyUser"
                  name="IdCurrencyUser"
                  style={{ width: '100%' }}
                  variant="outlined"
                  disabled
                  value={EligibilityForm.CurrencyName}
                />
              </FormControl>
            </Grid>
            {EligibilityForm.CurrencyName === 'Dólares' ? (
              <Grid item xs={4} sm={4} md={4}>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Monto moneda USD</label>
                </Grid>
                <FormControl style={{ width: '100%' }}>
                  <NumberFormat
                    id="TotalSubProjectBudget"
                    name="TotalSubProjectBudget"
                    customInput={TextField}
                    thousandSeparator={true}
                    value={EligibilityForm.TotalSubProjectBudgetDollar}
                    decimalScale={2}
                    disabled
                    autoComplete="off"
                    allowNegative={false}
                    variant="outlined"
                    inputProps={{ maxLength: 12 }}
                  />
                </FormControl>
              </Grid>
            ) : (
              <>
                <Grid item xs={4} sm={4} md={4}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Monto moneda local
                    </label>
                  </Grid>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="TotalSubProjectBudget"
                      name="TotalSubProjectBudget"
                      customInput={TextField}
                      thousandSeparator={true}
                      value={EligibilityForm.TotalSubProjectBudget}
                      decimalScale={2}
                      disabled
                      autoComplete="off"
                      allowNegative={false}
                      variant="outlined"
                      inputProps={{ maxLength: 12 }}
                      fixedDecimalScale
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={4} sm={4} md={4}>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Monto moneda USD
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="TotalSubProjectBudgetDollar"
                          name="TotalSubProjectBudgetDollar"
                          customInput={TextField}
                          thousandSeparator={true}
                          value={EligibilityForm.TotalSubProjectBudgetDollar}
                          autoComplete="off"
                          disabled
                          prefix="$"
                          allowNegative={false}
                          variant="outlined"
                          isNumericString={true}
                          inputProps={{ maxLength: 12 }}
                          decimalScale={2}
                          fixedDecimalScale
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.7. Monto del préstamo solicitado USD
              </label>
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="RequiredAmount"
                  name="RequiredAmount"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={EligibilityForm.RequiredAmount}
                  autoComplete="off"
                  disabled
                  prefix="$"
                  allowNegative={false}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 12 }}
                  decimalScale={2}
                  fixedDecimalScale
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <Button
                type="button"
                onClick={() => next()}
                className="button__wizard button__next"
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec1View
